import { render, staticRenderFns } from "./_logsTable.vue?vue&type=template&id=7bbfe014&scoped=true"
import script from "./_logsTable.vue?vue&type=script&lang=js"
export * from "./_logsTable.vue?vue&type=script&lang=js"
import style0 from "./_logsTable.vue?vue&type=style&index=0&id=7bbfe014&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7bbfe014",
  null
  
)

export default component.exports